resetStore